var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"custom-registration-wrapper",attrs:{"data-cy":"custom-registration"}},[(_setup.isSachkundeCompany)?_c(_setup.AcademySignup):_c(_setup.OtherAcademiesSignup)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }